import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueMeta from 'vue-meta'
import dateFilter from './filters/date.filter'
import langFilter from "./filters/lang.filter";
import currencyFilter from './filters/currency.filter'
import Vuelidate from 'vuelidate'
import 'materialize-css/js/materialize.min.js'
import toaster from '@/plugins/toaster'
import title from "@/plugins/title"
import Loader from '@/components/app/Loader'
import tooltip from '@/directives/tooltip.directive'
import Paginate from 'vuejs-paginate'

import firebase from '@firebase/app'
import '@firebase/database'
import '@firebase/auth'

Vue.filter('date', dateFilter)
Vue.filter('currencyFilter', currencyFilter)
Vue.filter('langFilter', langFilter)
Vue.config.productionTip = false
Vue.use(Vuelidate)
Vue.use(toaster)
Vue.use(VueMeta)
Vue.use(title)
Vue.component('Loader', Loader)
Vue.component('paginate', Paginate)
Vue.directive('tooltip', tooltip)

firebase.initializeApp({
  apiKey: "AIzaSyDR8n0pcvrwZl1tfU0fG2BUMQh7mW4YRG8",
  authDomain: "vuelearn-da0d6.firebaseapp.com",
  databaseURL: "https://vuelearn-da0d6.firebaseio.com",
  projectId: "vuelearn-da0d6",
  storageBucket: "vuelearn-da0d6.appspot.com",
  messagingSenderId: "935024307763",
  appId: "1:935024307763:web:3ebb973eb9e256607afd46"
})

let app

firebase.auth().onAuthStateChanged(() => {
  if (!app){
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})

